(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soft-reason-product-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sr-product-rail')) {
    customElements.define('sr-product-rail', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-sr-viewport]');
        this.controls = this.querySelector('.sr-rail__controls');
        if (!this.viewport || !this.controls) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.previous = this.querySelector('[data-sr-direction="-1"]');
        this.next = this.querySelector('[data-sr-direction="1"]');
        const update = () => {
          const limit = this.viewport.scrollWidth - this.viewport.clientWidth;
          this.controls.hidden = limit < 2;
          this.previous.disabled = this.viewport.scrollLeft <= 2;
          this.next.disabled = this.viewport.scrollLeft >= limit - 2;
          this.style.setProperty('--sr-progress', String(limit > 0 ? Math.min(1, Math.max(0, this.viewport.scrollLeft / limit)) : 0));
        };
        this.controls.addEventListener('click', (event) => {
          const button = event.target.closest('[data-sr-direction]');
          if (!button) return;
          this.viewport.scrollBy({ left: this.viewport.clientWidth * Number(button.dataset.srDirection), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, options);
        this.viewport.addEventListener('scroll', update, { ...options, passive: true });
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.viewport);
        update();
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
